import { useEffect } from "react";

/**
 * useSeo — sets document title, meta description, canonical URL, and OG tags per page.
 * Also emits a GA4 page_view via gtag if available (SPA route change).
 */
export default function useSeo({
    title,
    description,
    canonical,
    ogTitle,
    ogDescription,
    ogImage,
    noindex = false,
}) {
    useEffect(() => {
        if (title) document.title = title;

        upsertMeta("name", "description", description);
        upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
        upsertMeta("property", "og:title", ogTitle || title);
        upsertMeta("property", "og:description", ogDescription || description);
        upsertMeta("property", "og:url", canonical);
        upsertMeta("property", "og:image", ogImage || "https://www.greenduck.com.br/og-image.svg");
        upsertMeta("name", "twitter:title", ogTitle || title);
        upsertMeta("name", "twitter:description", ogDescription || description);
        upsertMeta("name", "twitter:image", ogImage || "https://www.greenduck.com.br/og-image.svg");

        if (canonical) upsertLink("canonical", canonical);

        // SPA page_view for GA4 (works even before GTM tag is fully wired)
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
            try {
                window.gtag("event", "page_view", {
                    page_title: title,
                    page_location: window.location.href,
                    page_path: window.location.pathname + window.location.search,
                });
            } catch (_) {
                // ignore
            }
        }
        // dataLayer push for GTM
        if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: "spa_pageview",
                page_title: title,
                page_path: window.location.pathname + window.location.search,
            });
        }
    }, [title, description, canonical, ogTitle, ogDescription, ogImage, noindex]);
}

function upsertMeta(attr, key, value) {
    if (!value) return;
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", value);
}

function upsertLink(rel, href) {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}
